<template>
  <div class="modal-content fm-modal-preview">
    <div class="modal-header" style="box-shadow: 0 0 10px 0 rgba(0,0,0,.05)">
      <h5 class="modal-title w-75 text-truncate">
        {{ selectedItem.basename }}
      </h5>
      <button type="button" class="btn btn-primary" aria-label="Close" @click.prevent="hideModal">
        {{ $t('pages.documents.pdfviewer.return')}}
      </button>
    </div>
    <div class="modal-body">
      <div class="row modal-body-container">
        <div class="col-md-8 viewer-container">
          
          <!-- Display Image Files -->
          <v-zoomer style="width: 100%; height: 100%;"
            v-if="selectedItem.extension === 'jpg' || selectedItem.extension === 'jpeg' || selectedItem.extension === 'png'">
            <img :src="image" v-bind:style="{'max-height': 84+'vh'}"
              style="object-fit: contain; width: 100%; height: 100%;">
          </v-zoomer>
          
          <!-- Display mp3 Audio Files -->
          <!-- TODO: Implement Backend Streaming for mp3 and mp4 -->
          <audio-player v-if="selectedItem.extension === 'mp3'" />

          <!-- Display mp4 Video Files -->
          <video-player v-if="selectedItem.extension === 'mp4'" />

          <!-- Display pdf Portable Documents -->
          <pdf-viewer v-if="selectedItem.extension === 'pdf'" :url="pdfLink" :extension="selectedItem.extension" />
          
          <!-- Display Microsoft Office Files -->
          <iframe v-if="isOfficeExtension(selectedItem.extension)" frameborder="0" border="0" cellspacing="0"
            class="office-container" :src="OfficeDocumentLink">
          </iframe>

          <!-- Display dinflow Forms -->
          <div v-if="selectedItem.extension == 'form'" class="container mt-4">
            <div class="row">
              <div class="col-md-9 mx-auto">  
                <h3 v-if="typeof selectedItem.document_type === 'object'">
                  {{ selectedItem.document_type.name }}
                </h3>
                <h3 v-else>
                  {{ selectedItem.document_type }}
                </h3>
                <file-detail />
              </div>
            </div>
          </div>
        </div>
        <!-- File Details Section -->
        <div class="col-md-4 details-container">
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab :title="$t('pages.documents.pdfviewer.menu.forum')">
              <div class="forum-container">
                <div class="loader" v-if="isLoadingComments"></div>
                <div class="forum scroll" v-if="comments.length > 0">
                  <div v-for="(comment, index) in comments" :key="index" class="comment">
                    <img v-if="comment.picture != null" :src="load_image(comment.picture_small)" alt=""
                      style="border-radius: 50%" width="36" />
                    <img v-else src="@/assets/images/users/default.svg" alt="" style="border-radius: 8px" width="36" />
                    <span class="comment-user-name">{{ `${comment.firstname} ${comment.lastname}` }}</span>
                    <div class="comment-date">
                      <i class="bx bx-time"></i>
                      <!-- TODO: FIX THE TIME -->
                      {{ $d(new Date(comment.date), "short") }}
                    </div>
                    <p class="comment-text"> <span v-html="userMentioned(comment.message)"></span></p>
                  </div>
                </div>
                <div v-if="comments.length === 0 && !isLoadingComments" class="empty-state text-center">
                  <transition name="fade" appear>
                    <div>
                      <i class="bx bxs-file mb-3"></i>
                      <h5 class="mb-3">{{ $t('pages.documents.pdfviewer.empty.title') }}</h5>
                      <p>{{ $t('pages.documents.pdfviewer.empty.text') }}</p>
                    </div>
                  </transition>
                </div>
              </div>
              <div class="mentionable">
                <mentionable :document="selectedItem" @saved="onSubmitComment()"/>
              </div>
            </b-tab>
            <b-tab :title="$t('pages.documents.pdfviewer.menu.indexing')"
                    v-if="selectedItem.extension != 'form'">
              <file-detail />
            </b-tab>
            <b-tab :title="$t('pages.documents.pdfviewer.menu.process')" :active="isWorkflowTabActive">
              <process-document @changed="onChanged"/>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modal from '../mixins/modal';
import helper from '../../../router/mixins/helper';
import PdfViewer from '../../manager/PdfViewer.vue';
import FileDetail from '../../details/FileDetail.vue';
import ProcessDocument from './Workflow.vue';
import AudioPlayer from './AudioPlayer.vue';
import VideoPlayer from './VideoPlayer.vue';
import Mentionable from '../../mentionable.vue';
// import LottieAnimation from "lottie-web-vue";

export default {
  name: 'DocumentPreview',
  mixins: [modal, helper],
  components: { 
    PdfViewer, FileDetail,
    ProcessDocument, AudioPlayer,
    VideoPlayer, Mentionable,
    // LottieAnimation  
  },
  data() {
    return {
      text: "",
      users: {},
      pdfLink: '',
      comments: [],
      isLoadingComments: false,
    };
  },
  created() {
    this.setPdfLink();
    this.$store.dispatch("getUsers").then((response) => {
      this.users = response.data;
    });
    this.getComments();
  },
  mounted(){
    //
  },
  computed: {
    isWorkflowTabActive() {
      const taskRoutes = ['TasksPending', 'TasksCompleted', 'TasksSent'];
      return taskRoutes.includes(this.$route.name);
    },
    image() {
      let user = JSON.parse(localStorage.getItem('user'));
      return `${process.env.VUE_APP_DEFAULT_URL}/file-manager/preview?user_id=${user.id}&disk=public&path=${encodeURIComponent(this.selectedItem.path)}`;
    },
    OfficeDocumentLink() {
      const path = encodeURIComponent(this.selectedItem.path);
      const baseUrl = process.env.VUE_APP_DEFAULT_URL;
      const userId = JSON.parse(localStorage.getItem('user')).id;
      const OfficeOnlineUri = 'https://view.officeapps.live.com/op/embed.aspx?src='
      const fileLocation = `${OfficeOnlineUri}${baseUrl}/file-manager/office-edit/${userId}/${path}`;
      return fileLocation;
    },
    /**
     * Authorization required
     * @return {*}
     */
    auth() {
      return this.$store.getters['settings/authHeader'];
    },

    /**
     * Selected disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters['selectedDisk'];
    },

    /**
     * Selected file
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters['selectedItems'][0];
    },

    /**
     * Calculate the max height for image
     * @returns {number}
     */
    maxHeight() {
      // if (this.$store.state.modal.modalBlockHeight) {
      //   return this.$store.state.modal.modalBlockHeight - 170;
      // }
      return 100;
    },
  },
  methods: {
    onChanged() {
      this.$emit('changed');
    },
    isOfficeExtension(extension) {
      const extensions = ['docx','doc','xls','xlsx','ppt','pptx'];
      return extensions.includes(extension);
    },
    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    getComments() {
      this.isLoadingComments = true;
      this.$store.dispatch('getComments', this.selectedItem).then((response) => {
        this.isLoadingComments = false;
        this.comments = response.data;
      });
    },
    onSubmitComment() {
      this.getComments();
    },
    userMentioned(str) {
      /* eslint-disable no-useless-escape */
      return str.replace(/(\@[a-zA-Z0-9\-\_]+)/g, '<span class="font-weight-bold red">$1</span>')
    },
    /**
     * Set the Pdf file encoded Url
     * 
     * Author: Kevin OLENGA
     */
    setPdfLink() {
      let user = JSON.parse(localStorage.getItem('user'));
      this.pdfLink = `${process.env.VUE_APP_DEFAULT_URL}/file-manager/preview?user_id=${user.id}&disk=public&path=${this.selectedItem.path}`;
    },
  },
};
</script>

<style lang="scss">
    .fm-modal-preview {
        height: 100%;
        background-color: white;
        .modal-body {
            padding-bottom: 40px;
            height: 100%;
            .modal-body-container {
              height: 100%;
            }
            .details-container {
              height: 100%;
              overflow: scroll;
              border-left: 1px solid #f1f5fa;
            }            
            .office-container {
              width: 100%;
              height: 100%;
              border-style: none;
            }
            img {
                max-width: 100%;
            }
        }

        & > .d-flex {
            padding: 1rem;
            border-top: 1px solid #e9ecef;
        }
    }

    .loader {
      border: 6px solid #f3f3f3;
      border-radius: 50%;
      border-top: 6px solid #3498db;
      // border-bottom: 6px solid #3498db;
      // margin-top: 30vh;
      width: 36px;
      height: 36px;
      margin-left: auto;
      margin-right: auto;
      -webkit-animation: spin 2s linear infinite; /* Safari */
      animation: spin 1s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
      0% { -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .forum-container {
      height: calc(100vh - 270px);
    }
    .forum {
      height: 96%;
    }

    .forum .comment {
      border-radius: 10px;
      background-color: white;
      border: 2px solid #f1f5fa;
      padding: 10px;
      margin-top: 10px;
      &:hover {
         border-radius: 10px;
        background-color: #f1f5fa;
        border: 2px solid #f1f5fa;
        padding: 10px;
        margin-top: 10px;
      }
      .comment-user-name {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
      }
      .comment-text {
        margin-top: 10px;
      }
      .comment-date {
        float: right;
      }
    }

    .empty-state {
      position: relative;
      width: 70%;
      margin: auto;
      i {
        margin-top: 18vh;
        font-size: 72px;
        color: #e8ecf1;
      }
    }

    .forum-container .mentionable {
      width: auto;
      position: fixed;
      bottom: 55px;
    }
</style>
